import { Observable, map } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Characteristic } from '../entities/characteristic.entity';
import { WebApiService } from './web-api.service';

@Injectable({
  providedIn: 'root',
})
export class CharacteristicService {
  private readonly CHARACTERISTIC_PATH = '/api/v1.1/characteristic';
  private readonly MANY_CHARACTERISTICS_PATH = '/api/v1.1/characteristic/many';
  private readonly FROM_USER_PATH = '/api/v1.1/characteristic/getFromUser';

  constructor(private webApiService: WebApiService) {}

  /**
   * Gets one characteristic by defined code
   * @param code
   * @returns observable with characteristic
   */
  public getCharacteristic(code: string): Observable<Characteristic> {
    return this.webApiService
      .get(this.CHARACTERISTIC_PATH + '/' + code)
      .pipe(map((response) => new Characteristic().deserialize(response.data)));
  }

  /**
   * Get characteristics of patient
   * @param patientId
   * @param params
   * @returns
   */
  getPatientCharacteristics(
    patientId: string,
    params: any = {}
  ): Observable<Characteristic[]> {
    let queryParams = new HttpParams();

    Object.keys(params).forEach((key) => {
      queryParams = queryParams.append(key, params[key]);
    });

    return this.webApiService
      .get(this.FROM_USER_PATH + '/' + patientId, true, { params: queryParams })
      .pipe(
        map((response) =>
          response.data.map((item) => new Characteristic().deserialize(item))
        )
      );
  }

  /**
   * Creates characteristic for logged user
   * @param data
   * @returns observable with characteristic id
   */
  public postCharacteristic(data: any = {}): Observable<string> {
    return this.webApiService
      .post(this.CHARACTERISTIC_PATH, data)
      .pipe(map((response) => response.data));
  }

  /**
   * Creates patient characteristic
   * @param data
   * @returns observable with characteristic id
   */
  postPatientCharacteristic(data: any = {}): Observable<string> {
    return this.webApiService
      .post(this.CHARACTERISTIC_PATH, data)
      .pipe(map((response) => response.data));
  }

  /**
   * Creates many characteristics once
   * @param data
   * @returns observable with characteristic ids array
   */
  public postManyCharacteristics(data: any[] = []): Observable<string[]> {
    return this.webApiService
      .post(this.MANY_CHARACTERISTICS_PATH, data)
      .pipe(map((response) => response.data));
  }
}
